import Loading from "~/themes/cliente-unicredit/components/forms/Loading.vue";
import PrecompiledData from "~/themes/cliente-unicredit/components/forms/PrecompiledData.vue";
import PrecompiledDocument from "~/themes/cliente-unicredit/components/forms/PrecompiledDocument.vue";
import IdentityDocData from "~/components/forms/IdentityDocData.vue";
import IncomeData from "~/components/forms/IncomeData.vue";
import EmployerData from "~/components/forms/EmployerDataShort.vue";
import ClubUciConsent from "~/components/forms/ClubUciConsent.vue";
import ClubUciWarning from "~/components/forms/ClubUciWarning.vue";
import PersonalData from "~/themes/cliente-unicredit/components/forms/PersonalDataPz.vue";
import Promo from "~/components/forms/Promo.vue";
import PromoConfirm from "~/components/forms/PromoConfirm.vue";
import PromoTerms from "~/components/forms/PromoTerms.vue";
import TypKO from "~/components/typ/TypKO.vue";
import RequestPending from "~/components/ko/RequestPending.vue";
import RequestExpired from "~/components/ko/RequestExpired.vue";
import Typ from "~/components/typ/Typ.vue";
import RequestKO from "~/components/ko/RequestKO.vue";

export default {
    Loading,
    PrecompiledData,
    PrecompiledDocument,
    IdentityDocData,
    IncomeData,
    EmployerData,
    ClubUciConsent,
    ClubUciWarning,
    PersonalData,
    Promo,
    PromoConfirm,
    PromoTerms,
    RequestKO,
    TypKO,
    RequestPending,
    RequestExpired,
    Typ
}